module.exports = __webpack_public_path__ + "img/profile.116e1c43.jpg";